import { render, staticRenderFns } from "./InteractiveRoom.vue?vue&type=template&id=ade5b9f0&scoped=true&"
import script from "./InteractiveRoom.vue?vue&type=script&lang=js&"
export * from "./InteractiveRoom.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveRoom.vue?vue&type=style&index=0&id=ade5b9f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade5b9f0",
  null
  
)

export default component.exports